import $command from '@/utils/command'
import globalActions from '@/actions'
const state = {
    tree: [],
    list: [],
    current: {}
}
const mutations = {
    updateTree: (state, data) => {
        state.tree = data
        globalActions.setGlobalState({
            menu: state
        });
    },
    updateList: (state, data) => {
        state.list = data
        globalActions.setGlobalState({
            menu: state
        });
    },
    updateCurrent: (state, data) => {
        state.current = data
        globalActions.setGlobalState({
            menu: state
        });
    }
}
const actions = {
    async get({
        commit
    }) {
        if (state.list.length == 0) {
            const result = await $command.execute({
                api: "/core-api/sys/getMenu",
                parameter: {}
            })

            let websiteMenu = {};
            try {
                websiteMenu = await $command.execute({
                    api: "/core-api/cms/getArticleConfigList",
                    parameter: {
                        type: "ARTICLE"
                    }
                })
            } catch (e) {
                console.log(e)
            }
            result.data.items.forEach(parent => {
                if (parent.param1 == "website" && websiteMenu.code == 0) {
                    setUrl(websiteMenu.data)
                    parent.items = websiteMenu.data.items;
                }
            });
            let tree = result.data.items
            commit('updateTree', tree)
            let list = [];
            toList(list, result.data)
            commit('updateList', list)
        }
        return state
    },
}

function toList(list, tree) {
    list.push({
        feature: tree.feature,
        icon: tree.icon,
        id: tree.id,
        name: tree.name,
        parentId: tree.parentId,
        url: tree.url
    })
    if (tree.items && tree.items.length > 0) {
        tree.items.forEach(e => {
            toList(list, e)
        })
    }
}

function setUrl(arr) {
    if (arr.items) {
        arr.items.forEach(element => {
            element.config = element.config ? JSON.parse(element.config) : []
            if (element.parent == 0) {
                element.url = "/";
                configList.push(element);
            } else {
                element.url = "/core/cms/article-list/" + element.code;
            }
            return setUrl(element)
        })
    } else {
        return arr
    }
}
export default {
    namespaced: true,
    mutations,
    state,
    actions
}